import { useEffect } from "react";
import { useNavigate } from "react-router";

export default function PageNotFound(){
    const navigate = useNavigate();
    useEffect(()=>{navigate("/")})
    return <div/>
}